<template>
    <div>
        <app-sub-title text="Opciones del Menú" />
        <app-menu-form-filters
            @filter="onFilterProfiles"
            :menus="menus"
        />
        <app-menu-options-list
            :data="data"
            :on-change-page="onChangePage"
            @add-menu="addMenu"
            @sort="onSort"
        />

    </div>
</template>

<script>
import MenuOptionsList from '../MenuOptionsList/MenuOptionsList.vue';
import permissionManagerRepository from '../../../../repositories/permissionManager.repository.js';
import MenuFormFilters from '../MenuFormFilters/MenuFormFilters.vue';
export default {
    components: {
        appMenuOptionsList: MenuOptionsList,
        appMenuFormFilters: MenuFormFilters
    },
    props: {
        thePositionId: {
            required: true
        },
        menus:{
            type: Array
        }
    },
    data(){
        return{
            data: {},
            page: 1,
            filters: null,
            sort: {
                sortBy: 'name',
                sortDir: 'asc'
            }    
        }
    },

    methods: {
        loadMenuOptions(){
            const pmr = {...permissionManagerRepository};
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            pmr.getMenuOptions(filters, this.page)
            .then(data => this.data = data)
            .catch(error => toastr.error('Ocurrió un error al cargar las opciones de menú'));
        },
        onChangePage(page){
            this.page = page;
            this.loadMenuOptions();
        },
        addMenu(menuOption){
            const pmr = {...permissionManagerRepository};
            const formData = new FormData();
            formData.append('positionId', this.thePositionId);
            formData.append('menuOptionId', menuOption.id);
            pmr.savePositionMenuOption(formData)
            .then(data => {
                if (data.status) {
                    toastr.success(data.msg);
                } else {
                    toastr.error(data.msg);
                }
            })
            .catch(error => toastr.error('Ocurrió un error al agregar el menú al perfil'));
        },
        onFilterProfiles(filters){
            this.filters = filters;
            this.page = 1;
            this.loadMenuOptions();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadMenuOptions();
        }
    },

    created(){
        this.loadMenuOptions();
    }
}
</script>
